import { motion, AnimatePresence, useIsPresent} from 'framer-motion';
import React, { useEffect, useState, useRef } from 'react';

//Call by window.dispatchEvent(new CustomEvent('openNoiseAlert', {detail: { type: 'success', title: 'Alert!', text: 'This is an alert message.', duration: 5000 }}));
function Alert(){
    const [visible, setVisible] = useState(false);
    const [message, setMessage] = useState({type: 'info', title: 'Alert Title', text: 'Alert text body', duration: 4000});
    const closeTimeout = useRef(null);

    let bg_color = '';
    let border_color = '';
    let icon_color = '';
    let svg_icon = '';
    let text_color = 'black';


    switch(message.type){
        case 'info':
            text_color = 'text-sky-500';
            bg_color = 'bg-sky-500/15';
            border_color = 'border-sky-500/25';
            icon_color = 'bg-sky-500/15 text-sky-500';
            svg_icon = (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="size-6" aria-hidden="true">
                <path fillRule="evenodd" d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z" clipRule="evenodd" />
              </svg>);
            break;

        case 'success':
            text_color = 'text-green-500';
            bg_color = 'bg-green-500/15';
            border_color = 'border-green-500/25';
            icon_color = 'bg-green-500/15 text-green-500';
            svg_icon = (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="size-6" aria-hidden="true">
                 <path fillRule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z" clipRule="evenodd" />
                 </svg>);
            break;  
            
        case 'danger':
            text_color = 'text-red-500';
            bg_color = 'bg-red-500/15';
            border_color = 'border-red-500/25';
            icon_color = 'bg-red-500/15 text-red-500';
            svg_icon = (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="size-6" aria-hidden="true">
                <path fillRule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8.28 7.22a.75.75 0 0 0-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 1 0 1.06 1.06L10 11.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L11.06 10l1.72-1.72a.75.75 0 0 0-1.06-1.06L10 8.94 8.28 7.22Z" clipRule="evenodd" />
                </svg>);
            break;

          case 'warn':
            text_color = 'text-amber-500';
            bg_color = 'bg-amber-500/15';
            border_color = 'border-amber-500/25';
            icon_color = 'bg-amber-500/15 text-amber-500';
            svg_icon = (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-6" aria-hidden="true">
              <path fillRule="evenodd" d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-8-5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 10 5Zm0 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" clip-rule="evenodd" />
              </svg>);
            break;

        default:
            bg_color = '';
            border_color = '';
            icon_color = '';
            svg_icon = null;
            text_color = 'red';
    }

    useEffect(() => {
        const handleOpenAlert = (event) => {
            setMessage({
                type: event.detail.type ?? 'info',
                title: event.detail.title ?? 'Default Title',
                text: event.detail.text ?? 'Default Text',
                duration: event.detail.duration ?? 4000,
            });
            clearTimeout(closeTimeout.current);
            setVisible(true);
        };
    
        window.addEventListener('openNoiseAlert', handleOpenAlert);    
    
        return () => {
          window.removeEventListener('openNoiseAlert', handleOpenAlert);
          clearTimeout(closeTimeout.current);
        };
      }, []);

    const slideVariants = {
        hidden: { y: "-100%", x:"-50%", opacity: 0 }, // Starting position (hidden above the screen)
        visible: { y: "0%", x:"-50%" ,opacity: 1 },   // Final position (fully visible)
        exit: { y: "-100%", x:"-50%", opacity: 0 }    // Exit position (sliding back up)
      };

    useEffect(() => {
        if (visible) {
            closeTimeout.current = setTimeout(() => {
                setVisible(false);
            }, message.duration);
        }
    }, [visible, message.duration]);

    const handleClose = () => {
        clearTimeout(closeTimeout);
        setVisible(false);
    }

    return(
        <AnimatePresence>
        {visible && (
        <motion.div 
         initial="hidden"
         animate="visible"
         exit="exit"
         variants={slideVariants}
         className={`${border_color} fixed top-5 left-1/2 z-[9999] max-w-[380px] w-full overflow-hidden rounded-md border bg-white text-neutral-600`} role="alert">
          <div className={`${bg_color} flex w-full items-center gap-2 p-4`}>
            <div className={`${icon_color} rounded-full p-1" aria-hidden="true`}>
                {svg_icon}
            </div>
            <div className="ml-2">
              <h3 className={`${text_color} text-sm font-semibold`}>{message.title}</h3>
              <p className="text-xs font-medium sm:text-sm">{message.text}</p>
            </div>
            <button onClick={handleClose} type="button" className="ml-auto" aria-label="dismiss alert">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" stroke="currentColor" fill="none" strokeWidth="2.5" className="w-4 h-4 shrink-0">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <motion.div
                className="w-full bg-black bg-opacity-10 h-1 absolute bottom-0 left-0"
                initial={{ width: '100%' }}
                animate={{ width: visible ? '0%' : '100%' }}
                transition={{ duration: message.duration / 1000, ease: 'linear' }}
          />
        </motion.div>
        )}
        </AnimatePresence>      
    )
}


export default Alert;

